import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { utcToDate } from "../../utils/dateConvert";
import { rounding } from "../../utils/math";

class PowercutTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() { }

  render() {
    const sortedPowerCutList = [...this.props.powerCutList].sort(function (a, b) {
      var d = new Date(a.created);
      var c = new Date(b.created);
      return c - d;
    });

    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>Name</th>
            <th>Depot</th>
            <th>Last Reported</th>
            <th>Occured	</th>
            <th>Location</th>
            <th>SIM</th>
            <th>IMEI</th>
            <th>Engine</th>
            <th>Speed</th>
          </tr>
        </thead>
        <tbody>
          {sortedPowerCutList.map((list) => {
            return (
              <tr>
                <td>{list.assetName}</td>
                <td>{list.depotName}</td>
                <td>{utcToDate(list.lastReported)}</td>
                <td>{utcToDate(list.created)}</td>
                <td>{list.location}</td>
                <td>{list.sim}</td>
                <td>{list.imei}</td>
                <td>{list.engine ? "On" : "Off"}</td>
                <td>{rounding(list.speed)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default PowercutTable;
